module.exports = __webpack_public_path__ + "img/audiob.5ded86b9.gif";